import React, { Component } from 'react';
import { Button, DatePicker, Select } from 'antd';
import moment from 'moment';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import $ from '../../../common/AjaxRequest';

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        searchParams: {
            beginDateInvoiceClosed: null,
            endDateInvoiceClosed: null,
            paymentYear: moment().add( -1, 'y' ).format('YYYY'),
            lineOfBusiness: undefined,
        },
        businessList:[],
    }

    componentDidMount() {
        this.setQuarter(moment().format('YYYY-MM'), true);
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    handleParams = () => {
        const { searchParams:{ beginDateInvoiceClosed, endDateInvoiceClosed, paymentYear, lineOfBusiness } } = this.state;
        const { type } = this.props;
        const params = {}
        if( type == 'Year' ) {
            params.paymentYear = paymentYear;
            params.lineOfBusiness = lineOfBusiness;
        } else {
            params.beginDateInvoiceClosed = beginDateInvoiceClosed;
            params.endDateInvoiceClosed = endDateInvoiceClosed;
            params.lineOfBusiness = lineOfBusiness;
        }
        return params
    }
    search = () => {
        this.props.search( this.handleParams() )
    }

    export = () => {
        this.props.export( this.handleParams() );
    }
    reSolidify = () => {
        this.props.reSolidify();
    }

    setQuarter = (date, first) => {
        const dateObj = moment(date);
        const year = dateObj.year();
        const quarter = dateObj.quarter();
        let offset = 0;
        // 是否是一季度， 是（年份减一，季度设为四季度）
        const isFirstQuarter = offset && quarter == 1;
        const startMonth = 1 + 3 * ((isFirstQuarter ? 3 : quarter - 1 - offset));
        const endMonth = 3 * ((isFirstQuarter ? 4 : quarter - offset));
        const { searchParams } = this.state;
        searchParams.beginDateInvoiceClosed = `${year - (isFirstQuarter ? 1 : 0)}-${startMonth < 10 ? `0${startMonth}` : startMonth}`;
        searchParams.endDateInvoiceClosed = `${year- (isFirstQuarter ? 1 : 0)}-${endMonth < 10 ? `0${endMonth}` : endMonth}`;
        this.setState({ searchParams },() => {
            first && this.search();
        });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if( key == 'beginDateInvoiceClosed' ) {
            searchParams['endDateInvoiceClosed'] = value;
        }
        this.setState({searchParams})
    }

    disabledDate = ( current, type ) => {
        const { searchParams : { beginDateInvoiceClosed } } = this.state;
        console.log(beginDateInvoiceClosed);
        if( type == 'end' ) {
            return current && current.valueOf() < moment(beginDateInvoiceClosed).valueOf()
        } else {
            return current && current.valueOf() < moment(`202307`).valueOf()
        }
    }

    render () {
        const { searchParams: { beginDateInvoiceClosed, endDateInvoiceClosed, paymentYear, lineOfBusiness }, businessList } = this.state;
        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const{ type }=this.props;
        const statisticsDateOption = [];
        for (let start = 2016, end = Number(moment().format('YYYY')); start < end; start++) {
            statisticsDateOption.push(<Option key={start}>{start}</Option>);
        }
        return (
            <div className="filter-wrap" style={{ padding: 10, background: '#fff' }}>
                { type == "quarter" &&
                    <div className="filter-item">
                        <label className="filter-label">收款日期</label>
                        <MonthPicker
                            format={monthFormat}
                            allowClear={false}
                            disabledDate={(current) => this.disabledDate( current, 'begin')}
                            style={{width: 100, verticalAlign: 'middle'}}
                            value={beginDateInvoiceClosed ? moment(beginDateInvoiceClosed) : ''}
                            onChange={(date, dateString) =>  this.handleChange(dateString, 'beginDateInvoiceClosed')}
                        />
                        <label className="filter-label">~</label>
                        <MonthPicker
                            format={monthFormat}
                            allowClear={false}
                            style={{width: 100, verticalAlign: 'middle'}}
                            value={endDateInvoiceClosed ? moment(endDateInvoiceClosed) : ''}
                            disabledDate={(current) => this.disabledDate( current, 'end' )}
                            onChange={(date, dateString) =>  this.handleChange(dateString, 'endDateInvoiceClosed')}
                        />
                    </div>
                }
                {
                    type == "Year" && 
                    <div className="filter-item">
                        <label className="filter-label">收款日期</label>
                        <Select
                            showSearch={true}
                            allowClear={true}
                            style={{ width: 120, verticalAlign: 'middle' }}
                            placeholder="请选择"
                            optionFilterProp="children"
                            value={paymentYear}
                            onChange={value => this.handleChange(value, 'paymentYear')}
                        >
                            {statisticsDateOption}
                        </Select>
                    </div>
                }
                <div className="filter-item">
                    <label className="filter-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        style={{width: 120}}
                        value={lineOfBusiness}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                </Select>
                </div>
                <div className="filter-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
                <div className="filter-item"> 
                    <Button type="primary"  onClick={this.export} >导出</Button>
                </div>
                {
                    type == "quarter" && 
                    <div className="filter-item"> 
                        <Button type="primary"  onClick={this.reSolidify} >重新固化数据</Button>
                    </div>
                }
            </div>
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/homePage/returnedMoney/Filter.js